var _desc, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgFlagBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.999999999999858,
    height: 22.446812556199774,
    viewBox: "-0.4999999999999307 -0.5225268561997733 30.999999999999858 22.446812556199774",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.6.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 15 10.71)",
    id: "inpp3d0iYJocUsOw1tCqk"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(69,105,173)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "-15,-10.71 15,-10.71 15,10.71 -15,10.71 -9,0 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.4 0 0 0.4 12.06 10.71)",
    id: "YzIVGYf7nr2bPYuKvwfLI"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-24, -24)",
    d: "M 24 12 L 24 18 L 32 10 L 24 2 L 24 8 C 15.16 8 8 15.16 8 24 C 8 27.14 8.92 30.05 10.48 32.519999999999996 L 13.4 29.599999999999994 C 12.51 27.929999999999993 12 26.029999999999994 12 23.999999999999993 C 12 17.369999999999994 17.37 11.999999999999993 24 11.999999999999993 z M 37.519999999999996 15.48 L 34.599999999999994 18.4 C 35.489999999999995 20.07 35.99999999999999 21.97 35.99999999999999 24 C 35.99999999999999 30.63 30.629999999999992 36 23.999999999999993 36 L 23.999999999999993 30 L 15.999999999999993 38 L 23.999999999999993 46 L 23.999999999999993 40 C 32.83999999999999 40 39.99999999999999 32.84 39.99999999999999 24 C 39.99999999999999 20.86 39.07999999999999 17.95 37.519999999999996 15.48 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.45 0 0 0.45 12.06 10.7)",
    id: "nb8FEr2e8xNKYC_0REuaR"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-24, -24)",
    d: "M 0 0 L 48 0 L 48 48 L 0 48 z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgFlagBlue);
export default __webpack_public_path__ + "static/media/bg-flag-blue.bab2028e837063fd4cfa00da0c7c8ac7.svg";
export { ForwardRef as ReactComponent };